import { Injectable } from "@angular/core";
import * as AWS from "aws-sdk/global";
import S3 from "aws-sdk/clients/s3";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import { environment } from "src/environments/environment";
import { FileUpload } from "../classes/fileUpload";
@Injectable({
  providedIn: "root",
})
export class FileUploadService {
  contentType: any;
  constructor() { }
  uploadFile(file: any, filePath: any) {
    this.contentType = file.type;
    const bucket = new S3({
      accessKeyId: environment.s3accessKeyId,
      secretAccessKey: environment.s3secretAccessKey,
      region: environment.s3region,
    });
    const params = {
      Bucket: environment.s3BucketName,
      Key: filePath,
      Body: file,
      ACL: "private",
      ContentType: this.contentType,
    };
    console.log("@@params:", params);
    //for upload progress
    bucket.upload(params, function (err, data) {
      if (err) {
        console.log("There was an error uploading your file: ", err);
        return false;
      }
      console.log("Successfully uploaded file.", data);
      return true;
    });
  }
  uploadMultipleFiles(file, filePath: any) {
    // this.contentType = file.type;
    this.contentType = file.get('file').type;
    const bucket = new S3({
      accessKeyId: environment.s3accessKeyId,
      secretAccessKey: environment.s3secretAccessKey,
      region: environment.s3region,
    });
    const params = {
      Bucket: environment.s3BucketName,
      // Key: file.name,
      // Body: file,
      Key: file.get('name'),
      Body: file.get('file'),
      ACL: "private",
      ContentType: this.contentType,
    };
    console.log("@@params:", file, params);
    //for upload progress
    bucket.upload(params, function (err, data) {
      if (err) {
        console.log("There was an error uploading your file: ", err);
        return false;
      }
      console.log("Successfully uploaded file.", data);
      return true;
    });
  }
  getFiles(fileName) {
    console.log("@@File name:", fileName);
    const params = {
      Bucket: environment.s3BucketName,
      Key: fileName,
    };
    this.getS3Bucket().getObject(params, function (err, data) {
      if (err) {
        console.log("There was an error getting your files: " + err);
        return;
      }
      console.log("Successfully get files.", data);
      // const fileDatas = Buffer.from(data.Body).toString('utf8');
      const fileData = new TextDecoder().decode(data.Body);
      console.log("fileDatas", fileData);
    });
  }
  private getS3Bucket(): any {
    const bucket = new S3({
      accessKeyId: environment.s3accessKeyId,
      secretAccessKey: environment.s3secretAccessKey,
      region: environment.s3region,
    });
    return bucket;
  }
}
